import React from "react";

export default function CardComex({
  img,
  logo,
  nombre,
  empresa,
  cargo,
  texto,
}) {
  return (
    <div className="bg-sidom-light dark:bg-sidom-blue  w-[370px] h-[450px] border border-sidom-orange rounded-2xl shadow-lg p-10 flex-1 flex flex-col items-start justify-between    relative">
      <div className=" w-full ">
        <div className="flex items-start justify-start mb-2 relative">
          <img
            src={`https://api.institucional.global.sidom.io${img}`}
            alt={nombre}
            className="w-14 h-14 rounded-full object-cover  border-sidom-dark z-10"
            draggable={false}
          />
          <img
            src={`https://api.institucional.global.sidom.io${logo}`}
            alt={empresa}
            className="w-14 h-14 rounded-full object-contain border  -ml-4 z-20 bg-sidom-light"
            draggable={false}
          />
        </div>
        <h3 className="text-xl text-sidom-blue  dark:text-sidom-light font-bold mb-1 ">
          {nombre}
        </h3>
        <div className="min-h-[250px] ">
          <p className="font-semibold mb-4 text-sidom-blue dark:text-sidom-light text-base">
            {cargo}
          </p>
          <p className=" text-base text-sidom-blue  dark:text-sidom-light mb-2">
            {texto}
          </p>
        </div>
      </div>
    </div>
  );
}
